export default __webpack_public_path__ + "static/media/react.cd4ab684.jpg";